import KogAutoCompleteControlled from "@/main/components/shared/inputAutoComplete/autoCompleteControlled";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useDispatch } from "react-redux";

import { KeyValue } from "@/main/models/common";
import { StatusRegisterEnum } from "@/main/services/enum/StatusRegisterEnum";
import { getTranslateByKey, isNullUndefined, isValueQueryParams } from "@/main/services/utils";
import { getSupervisorsDomain, resetReducerSupervisors, useSupervisorReducer } from "@/main/store/supervisor";
import { useDinamicFiltersMappingCodes } from "./dinamicFiltersMappingCodes";

export const INITIAL_FORM_STATE_SUPERVISOR = {
	supervisor: null as KeyValue | null,
};

export type IFormFiltersMappingTypeSupervisor = typeof INITIAL_FORM_STATE_SUPERVISOR;

interface IFiltersMappingTypeSupervisorProps {}
function FiltersMappingTypeSupervisor(_props: IFiltersMappingTypeSupervisorProps) {
	const dispatch = useDispatch();
	const { watcherCountry, isRequiredField } = useDinamicFiltersMappingCodes();
	const { domain: supervisorsReducer } = useSupervisorReducer();

	const { control, resetField, setValue } = useFormContext<IFormFiltersMappingTypeSupervisor>();

	useEffect(() => {
		if (!isValueQueryParams(watcherCountry)) {
			resetField("supervisor");
		}
		if (isNullUndefined(watcherCountry)) return;

		dispatch(
			getSupervisorsDomain({
				guidCountry: String(watcherCountry?.key),
				idStatusRegister: StatusRegisterEnum.Active,
			}),
		);

		return () => {
			dispatch(resetReducerSupervisors());
		};
	}, [JSON.stringify(watcherCountry?.key)]);

	const disabledSupervisor = isNullUndefined(supervisorsReducer.data) || supervisorsReducer.data.length === 1;

	return (
		<KogAutoCompleteControlled
			id="id-mappingCode-select-supervisor"
			nameCustom="supervisor"
			label={getTranslateByKey("information.supervisor")}
			isDefaultValueUnique
			control={control}
			setValueCustom={setValue}
			options={supervisorsReducer.data}
			isLoading={supervisorsReducer.isLoading}
			disabled={disabledSupervisor}
			rulesCustom={{ required: isRequiredField("supervisor") }}
			onChangeCustom={() => {}}
		/>
	);
}

export default FiltersMappingTypeSupervisor;
